import * as React from "react";
import { IListingModel, IPatientListingCompensationModel } from "../../../models/IPatient";
import { TextInput } from "soprasteria-ui-library";
import { dateTimeToDateString } from "../../../helpers/DateHelper";

interface ICurrentListingModel {
    listing: IListingModel;
    patientListingCompensation: IPatientListingCompensationModel;
    revisionEndDate: Date | undefined;
    careNeedAreaNumber: number | undefined;
}
interface ICurrentListingMessageModel {
    message: string;
    isSysAdmin: boolean;
}

export const PatientCurrentListingInformation: React.FunctionComponent<ICurrentListingModel> = ({ listing, patientListingCompensation, revisionEndDate, careNeedAreaNumber }) => {
    return (
        <div className="information-wrapper">
            <h5>Patientens nuvarande listning</h5>
            <div className="row">
                <div className="col-12">
                    <TextInput name="readonlyOrganisation" defaultValue={listing.careProvider.displayOrganisationInformation} label="Vårdgivare" inlineLabel readonly />
                    <TextInput name="readonlyCareProvider" defaultValue={listing.careProvider.displayCareProviderName} label="Mottagning" inlineLabel readonly />
                    <TextInput name="readonlyRevisionEndDate" defaultValue={dateTimeToDateString(revisionEndDate)} label="Revisionsslut" inlineLabel readonly />
                    <TextInput name="readonlyCareNeedAreaNumber" defaultValue={careNeedAreaNumber?.toString()} label="Vårdbehovsområde" inlineLabel readonly />
                    {
                        patientListingCompensation?.listingCompensation ?
                            <>
                                <TextInput name="readonlyBaseAmount" defaultValue={patientListingCompensation.listingCompensation?.baseAmount.toString() + " kr"} label="Tandvårdspeng per månad" inlineLabel readonly />
                                <TextInput name="readonlyCareNeedAreaAddition" defaultValue={patientListingCompensation.listingCompensation?.careNeedAreaAddition.toString() + " kr"} label="Behovstillägg per månad" inlineLabel readonly />
                                {
                                    patientListingCompensation?.listingCompensation?.showRiskPotInformation ?
                                        <>
                                            <TextInput name="readonlyDeductionForRiskPotAmount" defaultValue={patientListingCompensation.listingCompensation?.deductionForRiskPotAmount?.toString() + " kr"} label="Avsättning tandvårdspeng" inlineLabel readonly />
                                            <TextInput name="readonlyDeductionForRiskPotAndCareNeedAreaAmount" defaultValue={patientListingCompensation.listingCompensation?.deductionForRiskPotAndCareNeedAreaAmount?.toString() + " kr"} label="Avsättning behovstillägg" inlineLabel readonly />
                                        </>
                                        : null
                                }
                            </>
                            : null
                    }
                    {
                        patientListingCompensation?.listingCompensationInformation ?
                            <>
                                <TextInput name="readonlyListingCompensationInformation" defaultValue={patientListingCompensation.listingCompensationInformation?.informationText} label="Ersättning" inlineLabel readonly />
                            </>
                            : null
                    }
                    {
                        patientListingCompensation?.additionalAssignmentCompensationInformation ?
                            <>
                                <TextInput name="readonlyAdditionalAssignmentCompensationInformation" defaultValue={patientListingCompensation.additionalAssignmentCompensationInformation?.informationText} label="Områdesansvar" inlineLabel readonly />
                            </>
                            : null
                    }                    
                </div>
            </div>
        </div>
    )
}
export const PatientCurrentListingInformationMessage: React.FunctionComponent<ICurrentListingMessageModel> = ({ message, isSysAdmin }) => {
    return (
        isSysAdmin ?
            <>

                <div>
                    <h5 style={{ paddingTop:85 }}>{message}</h5>
                </div>
            </>
            :
            <div>
                <h5 style={{ paddingTop: 75 }}>{message}</h5>
            </div>
    )
}